// config.js

const getCurrentEnvironment = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const envParam = urlParams.get("env");

  if (envParam && ["production", "preprod", "staging", "prodreplica"].includes(envParam)) {
    localStorage.setItem("preferredEnv", envParam);
    return envParam;
  }

  const preferredEnv = localStorage.getItem("preferredEnv");
  if (preferredEnv) {
    return preferredEnv;
  }

  const hostname = window.location.hostname;

  if (hostname === "localhost" || hostname === "127.0.0.1") {
    return "preprod";
  } else if (hostname.includes("devinfinitylearn.in")) {
    return "preprod";
  } else if (hostname.includes("infinitylearn.com")) {
    return "production";
  } else if (hostname.includes("inmobiusstaging-ui.devinfinitylearn.in")) {
    return "staging";
  } else {
    return "preprod";
  }
};

const ENVIRONMENT_CONFIGS = Object.freeze({
  production: {
    schoolLoginUrl: "https://admin.inmobiusinfinitylearn.com/login",
    baseUrl: {
      1: "https://admin.inmobiusinfinitylearn.com/api"
    },
    jobUrl: {
      1: "https://inmobiusjob.infinitylearn.com/api"
    },
    phoneBaseUrl: "https://gatewayapiinmobius.infinitylearn.com/api",
    otpBaseUrl: "https://comservice.infinitylearn.com/api",
    recaptchaSiteKey: "6LcLWcwrAAAAAMHP8O6cYf3uVpEjt3mtp4oBPZKb",
    scoreViewreportUrl: "https://scoreservice.infinitylearn.com/#",
    certficateUrl: "https://storage.googleapis.com/inmobius-user-assets-production/certificates",
    LsqUrl: "https://lsqservice.infinitylearn.com/api",
    report_link: "https://inmobiusreports.infinitylearn.com/",
    CC_reports_url: "https://storage.googleapis.com/inmobius-user-assets-production/reports/career_counselling/",
    oms_url: "https://omsapi.infinitylearn.com/",
    pip_GCS_url: "https://storage.googleapis.com/inmobius-assets-production",
    razorPayKey: "rzp_live_NoGaIDZ74lwGZa",
    JWE_KEY: "21e8deuchn384wwe^@&#1u2ede2dnkw2",
    packageMapping: {
      scorePrelims: "1236",
      "scoreSemi-Finals": "1237",
      scoreFinals: "1238",
      scoreofflinePrelims: "1236",
      "scoreofflineSemi-Finals": "1237",
      scoreofflineFinals: "1238",
      geniussemifinal: "1237",
      geniusfinal: "1238",
      iemsatPrelims: "1241",
      "iemsatSemi-Finals": "",
      iemsatFinals: "",
      hotsolympiadPrelims: "1239",
      "hotsolympiadSemi-Finals": "1305",
      hotsolympiadFinals: "1317",
      matholympiadPrelims: "1240",
      "matholympiadSemi-Finals": "1319",
      matholympiadFinals: "1320",
      scoreedgescholarshiptestPrelims: "1566",
      revisiontestPrelims: "1236",
      atreyascholarshiptestPrelims: "1566"
    }
  },

  preprod: {
    schoolLoginUrl: "https://adminpreprod.inmobiusinfinitylearn.com/login",
    baseUrl: {
      1: "https://adminpreprod.inmobiusinfinitylearn.com/api"
    },
    jobUrl: {
      1: "https://inmobiusjob.devinfinitylearn.in/api"
    },
    phoneBaseUrl: "https://gatewayapi.devinfinitylearn.in/api",
    otpBaseUrl: "https://comservice.devinfinitylearn.in/api",
    recaptchaSiteKey: "6LfSKrorAAAAALgCIJWzbndUFUSsQmv_A32b1j5w",
    scoreViewreportUrl: "https://scorepreprod.devinfinitylearn.in/#",
    certficateUrl: "https://storage.googleapis.com/inmobius-user-assets-preprod/certificates",
    LsqUrl: "https://lsqservice.devinfinitylearn.in/api",
    report_link: "https://inmobiusreports.devinfinitylearn.in/",
    CC_reports_url: "https://storage.googleapis.com/inmobius-user-assets-preprod/reports/career_counselling/",
    oms_url: "https://omsapi.devinfinitylearn.in/",
    pip_GCS_url: "https://storage.googleapis.com/inmobius-assets-preprod",
    razorPayKey: "rzp_test_12ntRUqV41EEBk",
    JWE_KEY: "21e8deuchn384wwe^@&#1u2ede2dnkw2",
    packageMapping: {
      scorePrelims: "301",
      "scoreSemi-Finals": "302",
      scoreFinals: "303",
      scoreofflinePrelims: "301",
      "scoreofflineSemi-Finals": "302",
      scoreofflineFinals: "303",
      geniussemifinal: "290",
      geniusfinal: "303",
      iemsatPrelims: "301",
      "iemsatSemi-Finals": "",
      iemsatFinals: "303",
      hotsolympiadPrelims: "301",
      "hotsolympiadSemi-Finals": "302",
      hotsolympiadFinals: "303",
      matholympiadPrelims: "301",
      "matholympiadSemi-Finals": "302",
      matholympiadFinals: "303",
      scoreedgescholarshiptestPrelims: "533",
      revisiontestPrelims: "533",
      atreyascholarshiptestPrelims: "533"
    }
  },

  staging: {
    schoolLoginUrl: "https://inmobiusstaging.devinfinitylearn.in/login",
    baseUrl: {
      1: "https://inmobiusstaging.devinfinitylearn.in/api"
    },
    jobUrl: {
      1: "https://inmobiusstaging.devinfinitylearn.in/api"
    },
    phoneBaseUrl: "https://gatewaystaging.devinfinitylearn.in/api",
    otpBaseUrl: "https://comservice.devinfinitylearn.in/api", // Using preprod as fallback
    recaptchaSiteKey: "6LfSKrorAAAAALgCIJWzbndUFUSsQmv_A32b1j5w", // Using preprod as fallback
    scoreViewreportUrl: "https://testservice.devinfinitylearn.in/#",
    certficateUrl: "https://storage.googleapis.com/inmobius-user-assets-stg/certificates", // Using preprod as fallback
    LsqUrl: "https://lsqservice.devinfinitylearn.in/api", // Using preprod as fallback
    report_link: "https://inmobiusreports.devinfinitylearn.in/", // Using preprod as fallback
    CC_reports_url: "https://storage.googleapis.com/inmobius-user-assets-stg/reports/career_counselling/", // Using preprod as fallback
    oms_url: "https://omsstagingapi.devinfinitylearn.in/",
    pip_GCS_url: "https://storage.googleapis.com/inmobius-assets-preprod", // Using preprod as fallback
    razorPayKey: "rzp_test_12ntRUqV41EEBk", // Using preprod as fallback
    JWE_KEY: "21e8deuchn384wwe^@&#1u2ede2dnkw2", // Using preprod as fallback
    packageMapping: {
      scorePrelims: "301",
      "scoreSemi-Finals": "302",
      scoreFinals: "303",
      scoreofflinePrelims: "301",
      "scoreofflineSemi-Finals": "302",
      scoreofflineFinals: "303",
      geniussemifinal: "290",
      geniusfinal: "303",
      iemsatPrelims: "301",
      "iemsatSemi-Finals": "",
      iemsatFinals: "303",
      hotsolympiadPrelims: "301",
      "hotsolympiadSemi-Finals": "302",
      hotsolympiadFinals: "303",
      matholympiadPrelims: "301",
      "matholympiadSemi-Finals": "302",
      matholympiadFinals: "303",
      revisiontestPrelims: "301"
    }
  },

  prodreplica: {
    schoolLoginUrl: "https://poc.inmobiusinfinitylearn.com/login",
    baseUrl: {
      1: "https://poc.inmobiusinfinitylearn.com/api"
    },
    jobUrl: {
      1: "https://poc.inmobiusinfinitylearn.com/api"
    },
    phoneBaseUrl: "https://pocgateway.inmobiusinfinitylearn.com/api",
    otpBaseUrl: "https://comservice.devinfinitylearn.in/api", // Using preprod as fallback
    recaptchaSiteKey: "6LfSKrorAAAAALgCIJWzbndUFUSsQmv_A32b1j5w", // Using preprod as fallback
    scoreViewreportUrl: "https://scorepoc.devinfinitylearn.in/#",
    certficateUrl: "https://storage.googleapis.com/inmobius-user-assets-preprod/certificates", // Using preprod as fallback
    LsqUrl: "https://lsqservice.devinfinitylearn.in/api", // Using preprod as fallback
    report_link: "https://inmobiusreports.devinfinitylearn.in/", // Using preprod as fallback
    CC_reports_url: "https://storage.googleapis.com/inmobius-user-assets-preprod/reports/career_counselling/", // Using preprod as fallback
    oms_url: "https://omsapi.devinfinitylearn.in/", // Using preprod as fallback
    pip_GCS_url: "https://storage.googleapis.com/inmobius-assets-preprod", // Using preprod as fallback
    razorPayKey: "rzp_test_12ntRUqV41EEBk", // Using preprod as fallback
    JWE_KEY: "21e8deuchn384wwe^@&#1u2ede2dnkw2", // Using preprod as fallback
    packageMapping: {
      scorePrelims: "301",
      "scoreSemi-Finals": "302",
      scoreFinals: "303",
      scoreofflinePrelims: "301",
      "scoreofflineSemi-Finals": "302",
      scoreofflineFinals: "303",
      geniussemifinal: "290",
      geniusfinal: "303",
      iemsatPrelims: "301",
      "iemsatSemi-Finals": "",
      iemsatFinals: "303",
      hotsolympiadPrelims: "301",
      "hotsolympiadSemi-Finals": "302",
      hotsolympiadFinals: "303",
      matholympiadPrelims: "301",
      "matholympiadSemi-Finals": "302",
      matholympiadFinals: "303",
      revisiontestPrelims: "301"
    }
  }
});

// Get current environment
const currentEnvironment = getCurrentEnvironment();

// Environment switcher utility (for development)
export const EnvironmentSwitcher = {
  getCurrentEnvironment: () => currentEnvironment,

  setEnvironment: (env) => {
    if (ENVIRONMENT_CONFIGS[env]) {
      localStorage.setItem("preferredEnv", env);
      window.location.reload();
    } else {
      console.warn(`Invalid environment: ${env}`);
    }
  },

  getAvailableEnvironments: () => Object.keys(ENVIRONMENT_CONFIGS),

  // Helper to add environment switcher UI in development
  initSwitcher: () => {
    if (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1") {
      const switcher = document.createElement("div");
      switcher.style.cssText = `
        position: fixed;
        top: 10px;
        right: 10px;
        background: rgba(0,0,0,0.8);
        color: white;
        padding: 10px;
        border-radius: 5px;
        z-index: 9999;
        font-family: Arial, sans-serif;
        font-size: 12px;
      `;

      switcher.innerHTML = `
        <div>Env: ${currentEnvironment}</div>
        <select onchange="window.__ENV_SWITCHER.setEnvironment(this.value)" style="margin-top: 5px; font-size: 10px;">
          ${Object.keys(ENVIRONMENT_CONFIGS)
            .map((env) => `<option value="${env}" ${env === currentEnvironment ? "selected" : ""}>${env}</option>`)
            .join("")}
        </select>
      `;

      document.body.appendChild(switcher);
      window.__ENV_SWITCHER = EnvironmentSwitcher;
    }
  }
};

export const FEATURE_FLAGS = Object.freeze({
  deeplinkSignupOverlayWaitForEvents: false
});

// Main configuration object
export const CONFIG_VARS = Object.freeze({
  environment: currentEnvironment,

  // Spread the environment-specific config
  ...ENVIRONMENT_CONFIGS[currentEnvironment],

  // Common configuration (same across all environments)
  apiVersion: "v1",
  featureFlags: FEATURE_FLAGS,
  headers: {
    ["product-id"]: "1",
    ["tenant-id"]: "1"
  },
  router: {
    1: "school",
    2: "user",
    3: "teacher"
  },
  countryApiKey: "a1JiWnJrVVp3YmxheTdybjFtbDVId2xjOU1UYUZ4dUZHMVNBMk5pZA=="
});

// Initialize environment switcher in development
if (typeof window !== "undefined") {
  setTimeout(() => EnvironmentSwitcher.initSwitcher(), 100);
}

export default CONFIG_VARS;
